import { FC } from 'react';

import { GridColumn, GridRow, HSpacingContainer, useBreakpoint, VSpacingContainer } from '@hh.ru/magritte-ui';

import { BalanceCard } from 'components/BalanceAndBonuses/BalanceCard/BalanceCard';
import { BonusesCard } from 'components/BalanceAndBonuses/BonusesCard/BonusesCard';

export const BalanceAndBonusesCards: FC = () => {
    const { isMobile } = useBreakpoint();

    if (isMobile) {
        return (
            <GridRow>
                <GridColumn xs={4} s={8}>
                    <VSpacingContainer default={12}>
                        <BalanceCard />
                        <BonusesCard />
                    </VSpacingContainer>
                </GridColumn>
            </GridRow>
        );
    }

    return (
        <GridRow>
            <GridColumn xs={4} s={8} m={12}>
                <HSpacingContainer default={24}>
                    <BalanceCard />
                    <BonusesCard />
                </HSpacingContainer>
            </GridColumn>
        </GridRow>
    );
};
